<template>
  <div id="v-widget">
    <v-card>
      <v-toolbar card v-if="enableHeader" dark :class="toolbarBg" height="45px;">
        <v-toolbar-title><h5><v-icon>{{ toolbarIcon }}</v-icon>&nbsp;{{title}}</h5>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <slot name="widget-header-action"></slot>
        {{ $vuetify.breakpoint.mdAndUp ? this.toolbarDesc : "" }}
      </v-toolbar>
      <v-divider v-if="enableHeader"></v-divider>
      <v-card-text :class="contentBg" :style="contentStyle">
        <slot name="widget-content"></slot>
      </v-card-text>       
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'v-widget',
  props: {
    title: {
      type: String,
    },
    enableHeader: {
      type: Boolean,
      default: true
    },
    toolbarDesc: {
      type: String,
      default: ''
    },
    toolbarIcon: {
      type: String,
      default: 'people'
    },
    toolbarBg: {
      type: String,
      default: 'white'
    },
    contentBg: {
      type: String,
      default: 'white'
    },
    contentStyle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    };
  },
  computed: {
    
  },  
};
</script>

<style lang="stylus" scoped>
.tb-light-green {
  background-color: #6CBF49 !important;
  border-color: #6CBF49 !important
}

.tb-light-gray {
  background-color: #959595 !important;
  border-color: #959595 !important
}

.circle-color {
  background-color: #bf51b5 !important;
  border-color: #bf51b5 !important
}
.scroll-area {
  position: relative;
  height: calc(100vh - 35vh);
  overflow: auto;
}

.widget-color {
  contentBg: black;
  // toolbarBg: pa-2 indigo;
}
</style>


// WEBPACK FOOTER //
// src/components/VWidget.vue